// extracted by mini-css-extract-plugin
module.exports = {"Control":"Control_Control__3tsND","label":"Control_label__1NtMr","less":"Control_less__5T1Ih","more":"Control_more__1W9jI"};